// @ts-nocheck
import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export function TagCloudChart({ data }) {
  if (!data || data.length === 0) {
    return (
      <div className="bg-white p-4 rounded-lg shadow">
        <p className="text-center text-gray-500">データがありません</p>
      </div>
    );
  }

  // 上位10件のみ表示
  const topTags = data.slice(0, 10);

  const chartData = {
    labels: topTags.map(d => d.tag || d.name),
    datasets: [
      {
        label: '通話数',
        data: topTags.map(d => d.count || d.value),
        backgroundColor: 'rgba(59, 130, 246, 0.8)',
        borderColor: 'rgb(59, 130, 246)',
        borderWidth: 1
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y' as const, // 横棒グラフ
    plugins: {
      legend: {
        display: false
      },
      title: {
        display: true,
        text: 'タグ別通話数（上位10件）'
      }
    },
    scales: {
      x: {
        beginAtZero: true,
        ticks: {
          precision: 0
        }
      }
    }
  };

  return (
    <div className="bg-white p-4 rounded-lg shadow">
      <div style={{ height: '300px' }}>
        <Bar data={chartData} options={options} />
      </div>
    </div>
  );
}
